// components/DropdownSearch.tsx
import React, { forwardRef } from "react";

interface DropdownSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export const DropdownSearch = forwardRef<HTMLInputElement, DropdownSearchProps>(
  ({ searchTerm, onSearchChange }, ref) => {
    return (
      <div className="p-2 border-b border-[rgb(232,232,232)] mb-2">
        <div className="relative">
          <input
            ref={ref}
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search..."
            className="w-full px-3 py-2 pl-10 text-15 border border-[rgb(232,232,232)] rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
);

DropdownSearch.displayName = "DropdownSearch";
